import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';

export const Wrapper = styled.div<{ autoHeight?: boolean; transparentBackground?: boolean }>`
  ${(props) => `
    min-height: ${props.autoHeight ? 'auto' : '100vh'};
    background-color: ${props.transparentBackground ? 'transparent' : getColour('background', 'page')};
  `};
`;
